import { ApplicationRef, ErrorHandler, Injectable, Injector, NgModule } from '@angular/core';
import { AppComponent } from './app/app.component';
import { ServiceLocator } from './service-locator';
import { FooterComponent } from './app/pages/shared/footer/footer.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule, KeyValuePipe, NgForOf, NgIf, NgOptimizedImage, NgStyle } from '@angular/common';
import { HeaderFixedComponent } from './app/pages/shared/header-fixed/header-fixed.component';
import { HeaderBottomComponent } from './app/pages/shared/header-bottom/header-bottom.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CallbackFormComponent } from './app/pages/shared/callback-form/callback-form.component';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { provideClientHydration } from '@angular/platform-browser';
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from 'ngx-mask';
import { SimpleSearchComponent } from './app/pages/shared/simple-search/simple-search.component';
import { MatDialogContainer, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { EmailSubscriptionComponent } from './app/pages/shared/email-subscription/email-subscription.component';
import { FormElementRenderModule } from './app/module/form-element-render-module/form-element-render.module';
import { HeaderTopComponent } from './app/pages/shared/header-top/header-top.component';
import { FooterPrimaryComponent } from './app/pages/shared/footer/footer-primary/footer-primary.component';
import { UiIconComponent } from './app/ui/ui-icon/ui-icon.component';
import { AccessGuard } from './app/guards/access.guard';
import { ForbiddenComponent } from './app/pages/forbidden/forbidden.component';
import { AuthComponent } from './app/pages/auth/auth.component';
import { MatAnchor, MatButton } from '@angular/material/button';
import { SharedModule } from './app/module/shared/shared.module';
import { HeaderAgentComponent } from './app/pages/shared/header-agent/header-agent.component';
import { MatTooltip } from '@angular/material/tooltip';
import { FooterAgentComponent } from './app/pages/shared/footer-agent/footer-agent.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { CallToNdvComponent } from './app/pages/shared/call-to-ndv/call-to-ndv.component';
import { RadioComponent } from './app/ui/radio/radio.component';

/**
 * Фабрика обработчика ошибок
 */
export function errorHandlerFactory(): ErrorHandler {
    return new ConsoleErrorHandler();
}

@Injectable()
export class ConsoleErrorHandler implements ErrorHandler {
    /**
     * @inheritDoc
     */
    handleError(error: string | Error): void {
        console.error(error);
    }
}

@NgModule({
    declarations: [
        HeaderBottomComponent,
        HeaderFixedComponent,
        FooterComponent,
        CallbackFormComponent,
        SimpleSearchComponent,
        EmailSubscriptionComponent,
        HeaderTopComponent,
        FooterPrimaryComponent,
        ForbiddenComponent,
        AuthComponent,
        HeaderAgentComponent,
        FooterAgentComponent,
        CallToNdvComponent,
        RadioComponent,
    ],
  imports: [
    // BrowserModule.withServerTransition({ appId: 'serverApp' }),
    RouterOutlet,
    NgForOf,
    NgIf,
    NgOptimizedImage,
    KeyValuePipe,
    RouterLink,
    NgStyle,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    MatDialogContent,
    MatFormField,
    MatInput,
    MatDialogContainer,
    MatDialogTitle,
    FormElementRenderModule,
    UiIconComponent,
    MatButton,
    SharedModule,
    MatTooltip,
    MatAnchor,
    NgxMaskDirective,
    MatRadioGroup,
    MatRadioButton,
    NgxMaskDirective,
    NgxMaskPipe
  ],
    providers: [
        provideClientHydration(),
        AccessGuard,
        provideNgxMask()
    ],
  exports: [
    FooterComponent,
    HeaderBottomComponent,
    HeaderFixedComponent,
    FormsModule,
    ReactiveFormsModule,
    SimpleSearchComponent,
    EmailSubscriptionComponent,
    CallbackFormComponent,
    HeaderTopComponent,
    FooterPrimaryComponent,
    HeaderAgentComponent,
    FooterAgentComponent,
    CallToNdvComponent,
    RadioComponent,
  ],
})
export class AppModule {
    /**
     * Конструктор
     */
    constructor(
        applicationRef: ApplicationRef,
        private injector: Injector,
    ) {
        ServiceLocator.init(injector);
    }
}
